import { ConfirmDialog } from "@zfp-akademie-a-s/zfp-design";
import type { AgentSummary } from "Infrastructure/ApiZfp/Schema";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { useTakeBackEditAccess } from "./useTakeBackEditAccess";
import { getAgentFullName } from "./utils";

type Props = {
  readonly isOpen: boolean;
  readonly advisor: AgentSummary | null;
  readonly onClose: () => void;
};

export const TakeBackConfirmDialog = ({ isOpen, advisor, onClose }: Props) => {
  const { t } = useResource();
  const { takeBack, isTakingBack } = useTakeBackEditAccess();

  return (
    <ConfirmDialog
      open={isOpen}
      title={t(Resources.AnalysisDetail.Sharing.Confirm.TakeBack.Title)}
      message={t(Resources.AnalysisDetail.Sharing.Confirm.TakeBack.Text, {
        advisorName: advisor ? getAgentFullName(advisor) : "",
        advisorId: advisor?.ssoId ?? "",
      })}
      cancelLabel={t(Resources.Common.Cancel)}
      confirmLabel={t(Resources.AnalysisDetail.Sharing.TakeOver)}
      onConfirm={() => takeBack({ onSettled: onClose })}
      onCancel={onClose}
      isPending={isTakingBack}
    />
  );
};
